import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'orderBatchesPicking';
export const orderBatchesPickingActions = makeActions(
  MODEL_NAME,
  'id',
  'order-batches',
);

export const getAllOrderBatchesPicking = orderBatchesPickingActions.getAll;
export const editOrderBatchesPicking = orderBatchesPickingActions.edit;
export const createOrderBatchesPicking = orderBatchesPickingActions.create;
export const getByIdOrderBatchesPicking =
  orderBatchesPickingActions.getDataById;
